import type { IntlShape } from 'react-intl';

import { computeText } from '@/locales/utils';

type BannerHeadersConfig = {
    intlPrefix: string;
    linkColumnKey: string;
    statusWidth?: number;
};

export const getBannerHeaders = (
    intl: IntlShape,
    { intlPrefix, linkColumnKey, statusWidth = 120 }: BannerHeadersConfig,
) => [
    {
        Header: computeText(intl, `${intlPrefix}.table.name`),
        accessor: 'name',
        width: 250,
        maxWidth: 250,
    },
    {
        Header: computeText(intl, `${intlPrefix}.table.status`),
        accessor: 'status',
        width: statusWidth,
    },
    {
        Header: computeText(intl, `${intlPrefix}.table.source`),
        accessor: 'source',
        width: 120,
    },
    {
        Header: computeText(intl, linkColumnKey),
        accessor: 'linkType',
        width: 200,
    },
    {
        Header: computeText(intl, `${intlPrefix}.table.actions`),
        accessor: 'actions',
        width: 190,
        disableSortBy: true,
    },
];
